import type { MainGenre, SubGenre } from '@intelligence/components/GenreSelectMiddleware/types';
import type { SelectGames } from '@/pages/intelligence/components/AllGameSelector/types';

const JOINER = '$$';

export const serializeMainGenreValue = (payload: MainGenre) => {
  const relation = payload?.relation || 'or';
  const value = payload?.value || '';
  return !value ? '' : `${relation}${JOINER}${value}`;
};

export const deserializeMainGenreValue = (payload: string): MainGenre | null => {
  if (!payload) return null;
  const [relation, value] = payload?.split(JOINER) || [];
  return { relation, value, checked: false, indeterminate: false };
};

export const serializeSubGenreValue = (payload: SubGenre) => {
  const parentValue = payload?.parentValue || '';
  const value = payload?.value || '';
  return !parentValue || !value ? '' : `${parentValue}${JOINER}${value}`;
};

export const deserializeSubGenreValue = (payload: string): SubGenre | null => {
  if (!payload) return null;
  const [parentValue, value] = payload?.split(JOINER) || [];
  return { parentValue, value, checked: true };
};

const GAME_SERIALIZE_VERSION = 'v2';

interface SerializedGameShapeV1 {
  v: 'v1';
  id: string;
  name: string;
  entityType?: SelectGames['entityType'];
}

interface SerializedGameShapeV2 {
  v: 'v2';
  id: string;
  name: string;
  entityType?: SelectGames['entityType'];
  cover?: string;
}

type SerializedGameShape = SerializedGameShapeV1 | SerializedGameShapeV2;

export const serializeSelectedGameValue = (payload: SelectGames) => {
  if (!payload?.id) return '';
  const serializeObj: SerializedGameShape = {
    v: GAME_SERIALIZE_VERSION as 'v2',
    id: String(payload.id || ''),
    name: String(payload.name || ''),
    entityType: payload?.entityType,
    cover: payload?.cover || payload?.cover_url || payload?.console_cover || payload?.pc_cover || '',
  };
  try {
    return encodeURIComponent(JSON.stringify(serializeObj));
  } catch (error) {
    return '';
  }
};

export const deserializeSelectedGameValue = (payload: string): SelectGames | null => {
  if (!payload) return null;
  try {
    const decoded = JSON.parse(decodeURIComponent(payload)) as SerializedGameShape;
    if (!decoded?.id) return null;
    const base: SelectGames = {
      id: decoded.id,
      name: decoded?.name || '',
      entityType: decoded?.entityType,
    } as unknown as SelectGames;

    if (decoded?.v === 'v2' && 'cover' in decoded) {
      base.cover = decoded.cover || '';
    }

    return base;
  } catch (error) {
    return null;
  }
};
